/**
 * WMS mode enums extracted from `redo/model/src/wms/wms-constants.ts` so
 * leaf packages (and the OutboundLabelSettings slice) can reference them
 * without a model↔leaf cycle. The rest of `wms-constants.ts` (helpers that
 * depend on the model storage-location schema) stays in redo/model and
 * re-imports these.
 *
 * Persisted to Mongo — keep in sync with the `typedEnum` registrations in
 * `redo/backend/db/schema/src/team/OutboundLabelSettings.ts`.
 */
export enum TransferDistributionMode {
  BIN_FIRST = "bin-first",
  ITEM_FIRST = "item-first",
}

export enum TransferPutawayOrder {
  SCAN = "scan",
  ROUTE = "route",
}

export enum ReceivingMode {
  RECEIVE = "receive",
  RECEIVE_AND_PLACE = "receive_and_place",
  BOTH = "both",
}

export enum SameBinSortMode {
  SKU = "sku",
  ORDER_DATE = "order-date",
}

export enum ZonePickingMode {
  NONE = "none",
  SEQUENTIAL_OPT_IN = "sequential_opt_in",
  SEQUENTIAL = "sequential",
}

export enum PickRouteStrategy {
  SHORTEST = "shortest",
  BIN_NAME = "bin_name",
}
